import notifications from '@sigma-frontend-libs/messages/ru/notifications'
import sendings from '@sigma-frontend-libs/messages/ru/sendings'

export default {
  titles: {
    variables: 'Переменные'
  },

  labels: {
    notification: 'Уведомление',
    subject: 'Тема',
    body: 'Тело шаблона',
    channel: 'Канал',
    owner: 'Адресат',
    targetUser: 'Адресат',
    type: 'Тип',
    text: 'Текст',
    sentAt: 'Отправлено в',
    isRead: 'Статус'
  },

  hints: {
    variables: 'Пожалуйста, обратитесь к документации, чтобы узнать больше о правильном заполнении шаблонов и использовании переменных.'
  },

  channels: sendings.types,
  events: notifications.types,
  childrenUsersEvents: notifications.types,

  email: {
    smtp: {
      host: 'Хост',
      port: 'Порт',
      from: 'От',
      login: 'Имя пользователя',
      password: 'Пароль'
    },

    templates: notifications.types
  },

  sms: {
    sendername: 'Имя отправителя',
    senderUserId: 'Отправитель',
    templates: notifications.types
  },

  web: { templates: notifications.types },
  push: { templates: notifications.types },
  tgBot: { templates: notifications.types },

  snackbars: {
    updated: 'Настройка успешно обновлена.'
  },

  isRead: {
    true: 'Прочитано',
    false: 'Не прочитано',
    sent: 'Отправлено: {date}',
    delivered: 'Доставлено: {date}'
  },

  tooltips: {
    channel: {
      on: 'Включён',
      off: 'Выключен'
    }
  }
}
